(() => {
  if (customElements.get('viveur-characters')) return;
  class ViveurCharacters extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;
      this.tabs = Array.from(this.querySelectorAll('[data-vv-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-vv-panel]'));
      if (!this.tabs.length) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.querySelector('[role="tablist"]').hidden = false;
      this.panels.forEach((panel, index) => {
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', this.tabs[index].id);
        panel.tabIndex = 0;
      });
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(tab.dataset.vvTab), options);
        tab.addEventListener('keydown', event => {
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          else if (event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.tabs.length - 1;
          else return;
          event.preventDefault();
          this.tabs[next].focus();
          this.select(this.tabs[next].dataset.vvTab);
        }, options);
      });
      document.addEventListener('click', event => {
        const link = event.target.closest('[data-vv-character]');
        if (!link || link.dataset.vvSection !== this.dataset.sectionId) return;
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.select(link.dataset.vvCharacter);
        this.scrollIntoView({ block: 'start', behavior: 'auto' });
        this.tabs.find(tab => tab.dataset.vvTab === link.dataset.vvCharacter)?.focus({ preventScroll: true });
      }, options);
      document.addEventListener('shopify:block:select', event => {
        if (event.detail?.sectionId === this.dataset.sectionId) this.select(event.detail.blockId);
      }, options);
      this.select(this.tabs[0].dataset.vvTab);
      // Follow a character link opened in a new tab or restored from history.
      const match = this.panels.find(panel => '#' + panel.id === window.location.hash);
      if (match) this.select(match.dataset.vvPanel);
    }
    select(key) {
      if (!this.tabs.some(tab => tab.dataset.vvTab === key)) return;
      this.tabs.forEach(tab => {
        const selected = tab.dataset.vvTab === key;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });
      this.panels.forEach(panel => { panel.hidden = panel.dataset.vvPanel !== key; });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.initialised = false;
    }
  }
  customElements.define('viveur-characters', ViveurCharacters);
})();
